import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapSidebarTabsComponent } from './map-sidebar-tabs.component';
import {DxTabsModule} from 'devextreme-angular';
import {MapSidebarFilterModule} from '../map/map-sidebar-filter/map-sidebar-filter.module';


@NgModule({
  declarations: [MapSidebarTabsComponent],
    imports: [
        CommonModule,
        DxTabsModule,
        MapSidebarFilterModule
    ],
  exports: [MapSidebarTabsComponent]
})
export class MapSidebarTabsModule { }
